<template>
  <div
    :class=" (editing || newReg)  ? 'rounded p-3 shadow' : 'border-bottom border-secondary'"
  >
    <div class="row pl-4 pr-4">
      <div class="row">
        <div class="col-md-12" v-if="!list">
          <label>{{$t(titulo)}}</label>
        </div>
      </div>
    </div>
    <div class="row pl-4 pr-4">
      <div class="col-md-4">
        <label>{{$t('nombre')}}</label>
        <input
          type="text"
          v-model="misDatos.name"
          :disabled="list === true"
          :class="{' border-bottom' : editing || newReg }"
        />
      </div>
      <div class="col-md-4">
        <label>{{$t('apellidos')}}</label>
        <input
          type="text"
          v-model="misDatos.lastname"
          :disabled="list === true"
          :class="{' border-bottom' : editing || newReg }"
        />
      </div>
      <div class="col-md-4 text-right pos-botones" v-if="list">
        <label>&nbsp;</label>
        <div class="btn-group float-right" role="group">
          <button type="button" class="btn btn-sm btn-primary btn-gr" @click.prevent="editarRegistro">
            <i class="fa fa-edit" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-sm btn-danger btn-gr" @click.prevent="eliminarRegistro">
            <i class="fa fa-trash-o" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="col-md-4 text-right pos-botones" v-else>
        <label>&nbsp;</label>
        <button
          class="btn btn-sm btn-success miBtn mr-0"
          @click.prevent="guardarRegistro"
        >{{ $t('guardar') }}</button>
        <button class="btn btn-sm miBtn ml-1" @click.prevent="cancelar">{{ $t('cancelar') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dog-cobreeder",
  props: ["datos", "dogId", "newReg", "editing", "list"],
  data: () => ({
    misDatos: {
      id: null,
      name: null,
      lastname: null,
      dog_id: null
    },
    titulo: "alta nuevo criador",
    listing: false
  }),
  methods: {
    editarRegistro: function() {     
      this.$emit("emitEditarCriador", this.misDatos);
    },
    eliminarRegistro: function() {      
      this.$emit("emitEliminarCriador", this.misDatos);
    },
    guardarRegistro: function() {
      if (this.editing === true) {      
        //vamos a guardar un registro
        this.$emit("emitEditarRegCriador", this.misDatos);
      } else {     
        this.$emit("emitCrearCriador", this.misDatos);
      }
    },
    cancelar: function() {
      this.$emit("emitCancelarFormCriador");
    }
  },
  mounted() {
    this.misDatos.dog_id = this.dogId;

    //si es un nuevo registro
    if (this.newReg === true) {
      this.titulo = "alta nuevo criador";
    } else if (this.editing === true) {
      //si vamos a editar un registro existente
      this.titulo = "editando un criador";
      this.misDatos = this.datos;
    } else {
      //si llego aquí es una lista
      this.misDatos = this.datos;
      console.log(this.misDatos);
    }
  }
};
</script>

<style scoped>
div.col-md-4 {
  padding: 0px 5px 0px 5px !important;
}
input {
  padding: 1px 0px 0px 10px !important;
  height: 28px;
  background-color: white;
  color: black !important;
}
input:focus {
  background-color: seashell;
  color: blue !important;
}
button.miBtn {
  min-width: 50px;
}
.pos-botones {
  margin-top: 28px;
}
</style>